/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sidebar_CreditsInputs */

const en_dashboard_sidebar_credits = /** @type {(inputs: Dashboard_Sidebar_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const es_dashboard_sidebar_credits = /** @type {(inputs: Dashboard_Sidebar_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creditos`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Dashboard_Sidebar_CreditsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_sidebar_credits = /** @type {((inputs?: Dashboard_Sidebar_CreditsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sidebar_CreditsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_sidebar_credits(inputs)
	return es_dashboard_sidebar_credits(inputs)
});